// Auth composable — admin session checking
import { ref } from 'vue'

const isAuthenticated = ref(false)
const adminUser = ref<{ email?: string; given_name?: string; family_name?: string } | null>(null)
const isLocalhost = ref(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '[::1]')
)

export function useAuth() {
  async function checkSession() {
    try {
      const res = await fetch('/api/admin/session', { cache: 'no-store' })
      if (res.ok) {
        const data = await res.json()
        if (data && data.authenticated) {
          isAuthenticated.value = true
          adminUser.value = {
            email: data.email,
            given_name: data.given_name,
            family_name: data.family_name,
          }
          return true
        }
      }
    } catch {
      // Keep default unauthenticated state
    }
    isAuthenticated.value = false
    adminUser.value = null
    return false
  }

  function getLoginUrl(): string {
    return isLocalhost.value ? '/dev/auth?role=admin' : '/api/admin/login'
  }

  function logout() {
    window.location.href = '/api/admin/logout'
  }

  return {
    isAuthenticated,
    adminUser,
    isLocalhost,
    checkSession,
    getLoginUrl,
    logout,
  }
}
